<template>
    <BreadCrumb PageTitle="Paiement par Stripe d'un BESC" />
    <PaiementStripe />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PaiementStripe from "@/components/BESC/PaiementStripe.vue";
  
    export default defineComponent({
      name: "PaiementStripePage",
      components: {
        BreadCrumb,
        PaiementStripe,
      },
    });
  </script>